import { ApiGet, ApiPost } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '@/stores/SettingsStore.ts'
import type {
  IProductReviewResponse,
  IProductReviewCreate,
  IProductReviewDelete,
  IProductReviewCreateResponse,
  IProductReviewFileCreate,
  IProductReviewUpdate,
  IProductReviewUpdateResponse,
  IProductReviewFileDelete
} from '@/types/ProductReviewTypes.d.ts'


export async function ProductReviewsGet(productCode: string): Promise<IProductReviewResponse> {
  const url = await GetOrderEntryConnectorUrl('ProductReviewApprovedGetList')
  return ApiGet(url, { productCode })
}

export async function ProductReviewUserGet(productCode: string, beeNumber: number): Promise<IProductReviewResponse> {
  const url = await GetOrderEntryConnectorUrl('ProductReviewUserGet')
  return ApiGet(url, { productCode, beeNumber })
}

export async function ProductReviewCreate(productReviewCreate: IProductReviewCreate) : Promise<IProductReviewCreateResponse> {
  const url = await GetOrderEntryConnectorUrl('ProductReviewCreate')
  return ApiPost(url, productReviewCreate)
}

export async function ProductReviewDelete(productReviewDelete: IProductReviewDelete) {
  const url = await GetOrderEntryConnectorUrl('ProductReviewDelete')
  return ApiPost(url, productReviewDelete)
}

export async function ProductReviewFileCreate(productReviewFileCreate: IProductReviewFileCreate, formData : FormData) {
  const url = await GetOrderEntryConnectorUrl('ProductReviewFileCreate', '?productCode=' + productReviewFileCreate.productCode + '&aoeProductReviewId=' + productReviewFileCreate.aoeProductReviewId + '&fileType=' + productReviewFileCreate.fileType)
  return ApiPost(url, formData)
}

export async function ProductReviewUpdate(productReviewUpdate: IProductReviewUpdate): Promise<IProductReviewUpdateResponse> {
  const url = await GetOrderEntryConnectorUrl('ProductReviewUpdate')

  const requestData = {
    AOEProductReviewId: productReviewUpdate.aoeProductReviewId,
    ProductCode: productReviewUpdate.productCode,
    Title: productReviewUpdate.title,
    Comments: productReviewUpdate.comments,
    BeeNumber: productReviewUpdate.beeNumber,
    Rating: productReviewUpdate.rating,
    IsApproved: false, //always false here, they need to be approved again
    IsAnonymous: productReviewUpdate.isAnonymous
  }

  return ApiPost(url, requestData)
}

export async function ProductReviewFileDelete(productReviewFileDelete: IProductReviewFileDelete) {
  const url = await GetOrderEntryConnectorUrl('productReviewFileDelete')
  return ApiPost(url, productReviewFileDelete)
}
